import type { BrandId } from "./types";

// Brand-owned metadata stays separate from the visual theme contract: it is
// consumed by both the browser bundle and vite.config.ts, so it must remain
// pure data with no React or asset imports.
export interface BrandMetadata {
  name: string;
  tagline: string;
  description: string;
}

const description =
  "Trade on the outcome of real-world events — sports, politics, crypto and more. " +
  "Buy and sell shares in what you think will happen.";

export const BRAND_METADATA = {
  smartmarket: {
    name: "Spark Spotz",
    tagline: "Spark Spotz — Predict everything",
    description,
  },
  richpoll: {
    name: "RichPoll",
    tagline: "RichPoll — Predict everything",
    description,
  },
} satisfies Record<BrandId, BrandMetadata>;
